import Config from "../config";
import {GlobalSearchResultModel} from "../models/modelsGlobalSearch";

export const globalSearchRecords = async (authToken: string, searchText: string): Promise<any[]> => {

    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/search/global`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");
      headers.append("crm-searchtext", `${searchText}`);

      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }
      const data = await response.json();

      if(!data ||
         !data.search_result){
          throw new Error("Unhandled error");
      }

      const searchResult = data.search_result;


      const allResults = Object.keys(searchResult).map((key) => {
        const resultJSON = searchResult[key]
        return new GlobalSearchResultModel().fromJSON(resultJSON);
      })

      return allResults

    } catch (error){
      throw new Error(`Error in global search: ${(error as Error).message}`)
    }
}
